module.exports = {
  site: require('./site'),
  user: require('./user'),
  permission: require('./permission')
}
